import { AccountingErrorResponse } from 'multirpc-sdk';
import { AxiosError } from 'axios';

import { isTFARequiredError } from './isTFARequiredError';
import { isWrongTOTPError } from './isWrongTOTPError';

export const isTFAError = (
  error: unknown,
): error is AxiosError<AccountingErrorResponse> =>
  isTFARequiredError(error) || isWrongTOTPError(error);
